import { useUserRoleForOrganization } from "domains/auth";
import { SetPaymentMethodDialog } from "domains/orgs/components/SetPaymentMethodDialog";
import { useActiveLocation } from "services/locationOrgContext";

export const useCanUpdatePaymentMethod = () => {
  const [location] = useActiveLocation();
  const isOrgAdmin = useUserRoleForOrganization(location.organization_id) === "ADMIN";
  return location.billing_source !== "ORGANIZATION" || isOrgAdmin;
};

export function UpdatePaymentMethodDialog({
  open,
  onClose,
  onSaved,
}: Readonly<{ open: boolean; onClose: () => void; onSaved: () => void }>) {
  const [location] = useActiveLocation();
  return (
    <SetPaymentMethodDialog
      open={open}
      title="Update payment method"
      onCancelUpdate={onClose}
      onSave={() => Promise.resolve(onSaved())}
      returnTo={`/locations/${location.id}/home`}
      isQwick={location.is_migrated_from_qwick}
      sourceId={
        location.billing_source === "ORGANIZATION"
          ? { organizationId: location.organization_id }
          : { locationId: location.id }
      }
    />
  );
}
